<form [formGroup]="contatoForm" id="contatoForm" #formElement (ngSubmit)="salvar()">
  <div class="row g-3">

    <ng-container *ngIf="!paginaEntidade">
      <!-- <ng-container *ngIf="vinculo">
        <div class="col-12 form-group mb-3">
          <label for="escolherContato" class="form-label required">Selecione um contato existente</label>
          <nz-select formControlName="escolherContato" nzShowSearch nzAllowClear
            nzPlaceHolder="Selecionar contato existente" nzSize="large" [compareWith]="compareFn">
            <nz-option [nzValue]="item" [nzLabel]="item?.nomeTipoContato"
              *ngFor="let item of tipoContatoList"></nz-option>
          </nz-select>
        </div>

        <nz-divider></nz-divider>
      </ng-container> -->

      <!-- <label nz-checkbox formControlName="flagPrincipal" (ngModelChange)="checkIfPrincipal($event)">Principal</label> -->

      <!-- <div class="col form-group">
        <label for="tipoContato" class="form-label required">Tipo de Contato</label>
        <nz-select formControlName="tipoContato" (ngModelChange)="onTipoContatoChange($event)" nzShowSearch nzAllowClear
          nzPlaceHolder="Tipo de Contato" nzSize="large" [compareWith]="compareFn">
          <nz-option [nzValue]="item" [nzLabel]="item?.nomeTipoContato" *ngFor="let item of tipoContatoList"></nz-option>
        </nz-select>
      </div> -->
    </ng-container>


    <div class="col-sm-5 form-group">
        <label for="pessoaEmail" class="form-label"
        [class.required]="tipoContatoId == tipoContatoEnum.EMAIL || tipoContatoId == tipoContatoEnum.EMAILAREAJURIDICA">E-mail
          <span nz-icon nzType="info-circle" nzTheme="outline" nz-popover
            nzPopoverContent="E-mail cadastrado na pessoa vinculada a este vínculo. Será usado para o envio de mailling, a não ser que exista um e-mail substituto."></span>
        </label>
        <nz-input-group nz-tooltip nzTooltipTitle="Email cadastrado para a pessoa" [disabled]="true" nzSize="large"
          class="email-pessoa-bloqueado">
          <input [disabled]="true" readonly nz-input formControlName="pessoaEmail" placeholder="E-mail" [maxlength]="150" />
        </nz-input-group>
        <small *ngIf="pessoaEmailInativo" class="text-danger fw-bold">E-mail inativo</small>
      <div
        *ngIf="contatoForm.get('pessoaEmail')?.invalid && (contatoForm.get('pessoaEmail')?.dirty || contatoForm.get('pessoaEmail')?.touched)">
        <div *ngIf="contatoForm.get('pessoaEmail')?.errors?.['required']" class="text-danger">E-mail é obrigatório.</div>
        <div *ngIf="contatoForm.get('pessoaEmail')?.errors?.['email']" class="text-danger">E-mail inválido.</div>
        <div *ngIf="contatoForm.get('pessoaEmail')?.errors?.['pattern']" class="text-danger">Formato de e-mail inválido.
        </div>
      </div>
    </div>

    <ng-container *ngIf="!usarEmailSubstituto">
      <div class="col-sm-5 form-group d-flex align-items-end">
        <button type="button" nz-button nzType="link" class="px-0" [disabled]="visualizar"
          (click)="mostrarEmailSubstituto()">
          Usar e-mail diferente para este vínculo
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="usarEmailSubstituto">
      <div class="col-sm-5 form-group">
        <label for="email" class="form-label">E-mail substituto
          <span nz-icon nzType="info-circle" nzTheme="outline" nz-popover
            nzPopoverContent="O mailling deste vínculo será enviado para este e-mail, e não para o e-mail da pessoa."></span>
        </label>
        <app-email-search-select formControlName="email" placeholder="E-mail substituto"></app-email-search-select>
        <button type="button" nz-button nzType="link" class="px-0 mt-1" [disabled]="visualizar"
          (click)="usarEmailDaPessoa()">
          Usar e-mail da pessoa
        </button>
      </div>
    </ng-container>

    <!--<div class="col-7 form-group">
      <label for="informacoesAdicionais" class="form-label">E-mail Geral</label>
      <nz-input-group nzSize="large">
        <input nz-input id="informacoesAdicionais" formControlName="informacoesAdicionais" placeholder="E-mail Geral" />
      </nz-input-group>
    </div>-->
  </div>
</form>
